// extracted by mini-css-extract-plugin
export var bodyRow = "_en-d";
export var cardColumns = "_en-e";
export var ellipsesOverflow = "_en-2";
export var flatBottomCorners = "_en-3";
export var flatTopCorners = "_en-4";
export var headerActionsDropdown = "_en-f";
export var headerBottomRow = "_en-c";
export var headerTopRow = "_en-b";
export var orderDetailsWrapper = "_en-0";
export var orderInfoContainer = "_en-1";
export var productDetails = "_en-9";
export var productImage = "_en-5";
export var responsiveTable = "_en-8";
export var shipmentContainer = "_en-a";
export var tableBottomLeft = "_en-6";
export var tableBottomRight = "_en-7";
export var trackingLink = "_en-g";